<template>
  <div>
    <div class="container">
      <el-button
        @click="
          () => {
            this.mobile = '';
            this.showDialog = true;
          }
        "
        type="primary"
        >添加打印员</el-button
      >
    </div>
    <div class="container">
      <el-table :data="list" border style="width: 100%">
        <el-table-column align="center" label="ID" prop="id" width="50" />
        <el-table-column label="打印员">
          <template slot-scope="{ row }">
            <div class="member">
              <div class="member-avatar">
                <img :src="row.avatar" class="member-avatar" alt="" />
              </div>
              <div>
                <div>{{ row.nickname }}</div>
                <div v-if="row.isvip === 2" class="member-tag">会员</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="mobile" />
        <el-table-column label="性别">
          <template slot-scope="{ row }">
            <div>{{ { 0: '未知', 1: '男', 2: '女' }[row.gender] }}</div>
          </template>
        </el-table-column>
        <el-table-column label="地区">
          <template slot-scope="{ row }">
            <div>{{ row.province }}/{{ row.city }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="{ row }">
            <el-button @click="onDel(row)" size="small" type="text">移除打印员身份</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="container" style="color: #999; font-size: 10px;">
      <i class="el-icon-warning-outline" style="color: #ff4f4f; font-size: 10px;"></i>
      打单软件<a href="https://developers.weixin.qq.com/miniprogram/dev/platform-capabilities/industry/express-download.html" style="color: #ff4f4f; margin-left: 3px;" targe="_blank">点此下载</a> (支持 Windows XP 及以上版本), 安装并配置热敏打印机（PC端需安装打印机驱动，并选择203dpi分辨率）
    </div>

    <el-dialog :title="'添加打印员'" :visible.sync="showDialog" width="30%" :before-close="handleClose">
      <el-row>
        <el-col span="19" style="margin-left:10px;">
          <el-input placeholder="手机号, (手机号必须已经成为此小程序的用户)" size="small" v-model="mobile"></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="onAdd">添加</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Tab from '../../../components/tab/index.vue';
import { M } from '../../../service/grpc.js';
import { rpc, rpc1 } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';

export default {
  data() {
    return {
      showDialog: false,
      list: [],
      token: '',
      mobile: ''
    };
  },
  async created() {
    this.token = getToken();
    var res = await rpc('StorePrinterService.GetWxPrinterList', M('Token', { token: this.token }));
    this.list = res.userlistList;
  },
  methods: {
    async onAdd() {
      var res = await rpc(
        'StoreUserService.GetUserList',
        M('UserListQueryRequest', {
          token: M('Token', { token: this.token }),
          mobile: this.mobile,
          count: 1
        })
      );
      if (!res.userlistList.length) {
        this.$message({
          message: '未找到该用户',
          type: 'error'
        });
        return;
      }
      var user = res.userlistList[0];
      res = await rpc(
        'StorePrinterService.AddWxPrinter',
        M('IDWithTokenRequest', {
          token: M('Token', { token: this.token }),
          id: user.id
        })
      );
      this.list.splice(0, 0, user);
      this.showDialog = false;
    },
    async onDel(row) {
      var res = await rpc(
        'StorePrinterService.DelWxPrinter',
        M('IDWithTokenRequest', {
          token: M('Token', { token: this.token }),
          id: row.id
        })
      );
      this.list.splice(this.list.findIndex(v => v.id === row.id), 1);
    }
  }
};
</script>

<style>
.member {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.member-avatar {
  width: 40px;
  height: 40px;
  margin-right: 8px;
}

.member-tag {
  font-size: 10px;
  color: #ff4f4f;
  background-color: #f0dcdc;
  width: 36px;
  text-align: center;
  line-height: 18px;
  border-radius: 3px;
}
.input-width {
  width: 170px;
}
.list-nodata {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  color: #999;
}
.list-tabs {
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 15px;
}
.el-select {
  width: 100%;
}
.item {
  margin-bottom: 10px;
}
.item:last-child {
  margin-bottom: none;
}
.order-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f8f8;
  padding: 5px 10px;
}

.table {
  box-sizing: border-box;
  border: 1px solid #e9e9e9;
  display: flex;
  justify-content: space-between;
}
.products {
  flex: 1;
  border-right: 1px solid #e9e9e9;
}
.action {
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.action-text {
  font-size: 14px;
  color: #666;
  padding-bottom: 10px;
}
.invoice {
  background-color: #e9e9e9;
  color: #4ba3dd;
  font-size: 12px;
  padding: 3px;
  border-radius: 3px;
}
.order-detail_text {
  color: #666;
  font-size: 14px;
}
.m10 {
  margin: 0 10px;
}
.member-tag {
  font-size: 10px;
  color: #ff4f4f;
  background-color: #f0dcdc;
  width: 36px;
  text-align: center;
  line-height: 18px;
  border-radius: 3px;
}
.product {
  display: flex;
  border-bottom: 1px solid #e9e9e9;
}
.product:last-child {
  border-bottom: none;
}
.product-info {
  padding: 10px;
  display: flex;
  flex: 1;
}
.product-img {
  width: 80px;
  height: 80px;
  margin-right: 10px;
  & > img {
    width: 80px;
    height: 80px;
  }
}
.product-name {
  margin-top: 10px;
  font-weight: bold;
  font-size: 14px;
  color: #333;
}
.product-desc {
  margin-top: 10px;
  font-size: 12px;
  color: #666;
}
.price,
.count {
  display: flex;
  width: 100px;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #e9e9e9;
}
</style>
